/** Riga etichette colonna sopra la lista (Piano 3 Task 4, parity mockup
 *  2026-07-13): stessa griglia della card (classe .griglia-ordini,
 *  stesso gap/px) cosi' le etichette restano allineate riga-su-riga con le
 *  celle sotto. Checkbox/thumbnail non hanno etichetta (colonne vuote). */
export function OrdiniColumnHeader() {
  return (
    <div
      className="griglia-ordini items-center px-4 pb-1.5 text-[11.5px] font-bold text-ink max-md:hidden"
      aria-hidden="true"
    >
      <span />
      <span />
      <span>Ordine e prodotto</span>
      <span>Stati</span>
      <span>Cliente</span>
      <span>Spedizione</span>
      <span className="text-right">Conti</span>
      <span className="text-right">Azioni</span>
    </div>
  );
}
